import { WEBINAR_DATA, WEBINAR_START_LOADER, WEBINAR_STOP_LOADER, WEBINAR_HIDE_ERROR, WEBINAR_SET_ERROR, } from "./../../interfaces/Home/iWebinar";
const initialState = {
    data: [],
    loader: false,
    errorData: {
        error: null,
        isOpen: false,
    },
};
const webinar = (state = initialState, action) => {
    switch (action.type) {
        case WEBINAR_DATA:
            return Object.assign(Object.assign({}, state), { data: action.payload.data });
        case WEBINAR_SET_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: action.payload.errorData });
        case WEBINAR_HIDE_ERROR:
            return Object.assign(Object.assign({}, state), { errorData: initialState.errorData });
        case WEBINAR_START_LOADER:
            return Object.assign(Object.assign({}, state), { loader: true });
        case WEBINAR_STOP_LOADER:
            return Object.assign(Object.assign({}, state), { loader: false });
        default:
            return Object.assign({}, state);
    }
};
export default webinar;
